<template>
    <div class="general-lottery">
        <new-blind-box-view :activityInfoObj="activityInfoObj"
            :tips="tips"
            :winnerList="winnerList"
            :drawType="drawType"
            :drawPointConsumption="drawPointConsumption"
            :balancePoints="balancePoints"
            :participateTimes="participateTimes"
            :loginType="loginType"
            :pointDrawFlag="pointDrawFlag"
            :isInMiniProgram="isInMiniProgram"
            :myRecord="myRecord"
            :ruleDesci="ruleDesci"
            :activityObj="activityObj"
            :drawStatus="drawStatus"
            :pageDisplayContent="pageDisplayContent"
            :tipsMessage="tipsMessage"
            @startLottery="startLottery"
            @viewPrizes="viewPrizes"
            @goWinnerList="goWinnerList"
            @goHiHonorMiniProgram="goHiHonorMiniProgram"
            @winningInquiry="winningInquiry"></new-blind-box-view>
        <transition name="van-fade">
            <mask-layer :maskLayerVisible="maskLayerVisible"
                :activityStatus="activityStatus"
                :activityInfoObj="activityInfoObj"
                :currentAward="curAwardInner"
                :popupType="popupType"
                :isInMiniProgram="isInMiniProgram"
                :loginType="loginType"
                :isReceived="isReceived"
                @closeMask="closeMask"
                @entityAwardOnlineHandler="entityAwardOnlineHandler"
                @nextStep="nextStep"
                @getUsedFlag="getUsedFlag"
                @virtualOnlineHandler="virtualOnlineHandler"
                @GeneralAwardHandler="GeneralAwardHandler"></mask-layer>
        </transition>
        <!-- 选择新盲盒样式用于实物+到店自提+无需预约导购+收集消费者信息时 -->
        <virtualizedAwardModal :activityUrl="activityUrl"
            :awardObj="curAwardInner"
            :userInfoList="userInfoList"
            :isFilledFlag="isFilledFlag"
            :activityObj="activityObj"
            :drawType="drawType"
            ref="virtualizedAwardModal"
            @openReceiveAwardModal="openReceiveAwardModal"
            @nextStep="nextStep"></virtualizedAwardModal>
    </div>
</template>

<script>
import newBlindBoxView from './components/new-blind-box-view.vue';
import maskLayer from './components/mask-layer.vue';
import { Dialog, Toast } from 'vant';
import { BigWheelConstants as BWC, MsgDialogType, NBBAwardPopupType } from '../../common/global-variable';
import wx from 'weixin-js-sdk';
import mixins from '../../mixin';
import virtualizedAwardModal from '../../../dynamicAttr/modal/virtualizedAwardModal.vue';
export default {
  // 普通抽奖
  name: 'GeneralLottery',
  components: { newBlindBoxView, maskLayer, virtualizedAwardModal },
  mixins: [mixins],
  props: {
    // 接口queryActivityBigWheelActivityDetailH5返回的活动信息
    activityInfoObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 中奖者名单
    winnerList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    // 初始抽奖还是积分抽奖
    // initDraw： 初始抽奖  pointDraw：积分抽奖
    drawType: {
      type: String,
      default: '',
    },
    // 每次抽奖需要积分数
    drawPointConsumption: {
      type: Number,
      default: 10,
    },
    // 剩余积分
    balancePoints: {
      type: String,
      default: '',
    },
    // 还可抽奖次数
    participateTimes: {
      type: Number,
      default: 0,
    },
    // 登录类型
    loginType: {
      type: String,
      default: '',
    },
    isLoginFlag: {
      type: Boolean,
      default: false,
    },
    // 积分抽奖标识，false -> 可正常抽奖，true -> 当前用户不是会员
    pointDrawFlag: {
      type: Boolean,
      default: false,
    },
    // 是否在小程序内
    isInMiniProgram: {
      type: Boolean,
      default: false,
    },
    // 我的中奖记录
    myRecord: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 抽奖机会已用完展示文案
    tips: {
      type: String,
      default: '',
    },
    // 活动规则
    ruleDesci: {
      type: String,
      default: '',
    },
    // 当前中奖奖品（不用了）
    currentAward: {
      type: Object,
      default: () => {
        return {};
      },
    },
    activityUrl: {
      type: String,
      default: '',
    },
    // 参与抽奖的用户类型
    userType: {
      type: String,
      default: '',
    },
    activityObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    userBase: {
      type: Object,
      default: () => {
        return {};
      },
    },
    // 用户的抽奖状态
    drawStatus: {
      type: String,
      default: '',
    },
    // 页面展示文案
    pageDisplayContent: {
      type: String,
      default: '',
    },
    // 弹窗提示语
    tipsMessage: {
      type: String,
      default: '',
    },
    // 弹框提示语对应code
    tipsMessageCode: {
      type: Number,
      default: null,
    },
    // 活动样式，默认新盲盒
    bigWheelActivityType: {
      type: String,
      default: '4',
    },
  },
  data() {
    return {
      BWC: BWC,
      maskLayerVisible: false,
      // 弹窗展示奖品类型
      popupType: '',
      // 当前中奖奖品，内部使用,初始值应为空对象
      curAwardInner: {},
      // 虚拟 + 线上兑换， 或实物+线上邮寄，是否已填写过用户信息领取了奖品
      isReceived: false,
      isFilledFlag: false, // 用于实物+到店自提+无需预约导购+收集消费者信息时，判断是否填写过消费者信息
      userInfoList: [], // 用于接收配置的实物+到店自提+无需预约导购+收集消费者信息
    };
  },
  computed: {
    // 活动状态
    activityStatus() {
      return this.activityInfoObj.activityStatus || '';
    },
    // 奖品池
    prizeList() {
      const tmp = [];
      if (this.activityInfoObj.bigWheelRewardList) {
        this.activityInfoObj.bigWheelRewardList.forEach((data) => {
          tmp.push(data);
        });
      }
      return tmp;
    },
  },
  watch: {
    curAwardInner: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal && Object.keys(newVal).length > 0) {
          this.isReceived = newVal.extendConfigFlag;
        }
      },
    },
  },
  methods: {
    // 点击按钮进行抽奖
    startLottery() {
      if (!this.isLoginFlag) {
        Toast('登录后参与活动哦！');
        return;
      }
      if (this.activityStatus !== BWC.ActivityStatus.running) {
        // 弹窗显示类型重置，解决活动已结束后，在我的奖品组件点击【查看】奖品，弹窗显示异常的问题
        this.popupType = '';
        this.openMask();
      } else {
        // 积分抽奖
        if (this.drawType === BWC.DrawType.PointDraw) {
          if (Number(this.balancePoints) < this.drawPointConsumption || this.participateTimes <= 0) {
            let message = '您的积分不足';
            if (this.drawStatus === BWC.status.exceedDailyTimes || this.drawStatus === BWC.status.exceedTotalTimes) {
              message = this.tipsMessage || '';
            }
            if (this.tipsMessageCode === 1501 || this.tipsMessageCode === 1502) {
              this.$emit('updateIsShowIdentityDialog');
            } else {
              this.noChance(message, MsgDialogType.VantDialog);
            }
          } else {
            this.$emit('pointer');
          }
        } else {
          // 其他类型的抽奖
          if (this.participateTimes <= 0) {
            if (this.tipsMessageCode === 1501 || this.tipsMessageCode === 1502) {
              this.$emit('updateIsShowIdentityDialog');
            } else {
              this.noChance(this.tipsMessage, MsgDialogType.VantDialog);
            }
          } else {
            this.$emit('pointer');
          }
        }
      }
    },
    // 打开弹窗
    openMask() {
      this.maskLayerVisible = true;
    },
    // 关闭弹窗
    closeMask() {
      this.maskLayerVisible = false;
    },
    /**
     * 中奖奖品处理，根据不同奖品类型，进行不同处理
     * @param {Object} award
     */
    winningAwardsHandler(award) {
      this.curAwardInner = Object.assign({}, award);
      let index = -1;
      for (let i = 0; i < this.prizeList.length; i++) {
        // 根据奖品ID与奖品池ID进行对比
        if (award.id === this.prizeList[i].id) {
          index = i;
          break;
        }
      }
      if (index === -1) {
        this.$utils.tips.message('warning', '奖项配置发生变化，请刷新页面后重试！');
      } else {
        if (this.curAwardInner.goodsType === BWC.GoodsType.noAward) {
          // 未中奖，显示未中奖弹窗
          this.popupType = NBBAwardPopupType.noAward;
        } else {
          // 中奖了，显示中奖通用弹窗，此处作为积分中奖
          this.popupType = NBBAwardPopupType.accumulatePoints;
        }
        // 打开弹窗
        this.openMask();
      }
    },
    // 新盲盒查看我的奖品
    openReceiveAwardModal() {
      this.$emit('openReceiveAwardModal', this.curAwardInner.writeOffCodeUrl);
    },
    /**
     * 查看中奖奖品
     * @param {Object} item
     */
    viewPrizes(item) {
      this.isFilledFlag = false;
      const award = Object.assign(item, { goodsType: item.rewardType });
      this.curAwardInner = Object.assign({}, award);
      // 奖品为积分，且跳转配置了自定义链接，则直接走跳转逻辑
      if (this.curAwardInner.goodsType === BWC.GoodsType.accumulatePoints && this.curAwardInner.jumpType === BWC.JumpType.customLink) {
        this.nextStep(this.curAwardInner.jumpUrl, this.curAwardInner.jumpType);
        return;
      }
      // 普通抽奖+新盲盒，用于实物+到店自提+无需预约导购+收集消费者信息时，需要根据配置显示或填写消费者信息
      if (
        item.rewardType === BWC.GoodsType.entityAward &&
        item.collectionType === BWC.CollectionType.inStore &&
        item.appointmentFlag === BWC.appointmentFlag.noNeed &&
        item.userInfoList &&
        item.userInfoList.length > 0
      ) {
        this.curAwardInner.bigWheelActivityType = Number(this.bigWheelActivityType);
        if (item.rewardRecordextendConfigPrivacy) {
          // 如果已填写消费者信息，进入抽奖页面直接回显展示
          this.userInfoList = item.rewardRecordextendConfigPrivacy.userInfoList || [];
          this.isFilledFlag = true;
        } else {
          // 如果未填写消费者信息，根据配置展示去填写
          this.userInfoList = item.userInfoList || [];
        }
        this.$refs.virtualizedAwardModal.openModel();
        return;
      }
      // 如果需要预约导购，且未进行核销，则应该打开通用弹窗，进行预约导购跳转
      if (this.appointmentGuideJudge(this.curAwardInner)) {
        this.popupType = NBBAwardPopupType.accumulatePoints;
      } else {
        // 无需预约导购，则更据奖品信息，分别弹窗
        this.prizesHandler(award);
      }
      // 打开弹窗
      this.openMask();
    },
    /**
     * 对单个奖品进分析，确定要显示的弹窗样式
     * @param {Object} award
     */
    prizesHandler(award) {
      if (award.goodsType === BWC.GoodsType.noAward) {
        // 未中奖，显示未中奖弹窗
        this.popupType = NBBAwardPopupType.noAward;
      } else if (award.goodsType === BWC.GoodsType.accumulatePoints || award.goodsType === BWC.GoodsType.coupon || award.goodsType === BWC.GoodsType.voucher) {
        // 积分，优惠券，代金券，直接显示奖品弹窗
        this.popupType = NBBAwardPopupType.accumulatePoints;
      } else if (award.goodsType === BWC.GoodsType.entityAward && award.collectionType === BWC.CollectionType.expressOrOnlineCheckOff) {
        // 实物 + 线上邮寄，需要先填写收件信息，然后提交
        // 存在已填写的信息时，需手动添加相关变量，使得弹窗进行回显
        if (this.curAwardInner.extendConfig) {
          const extendConfig = JSON.parse(this.curAwardInner.extendConfig);
          extendConfig.userName = this.curAwardInner.rewardRecordextendConfigPrivacy.userName;
          extendConfig.userPhone = this.curAwardInner.rewardRecordextendConfigPrivacy.userPhone;
          extendConfig.userAddress =
            this.curAwardInner.rewardRecordextendConfigPrivacy.userProvinceName +
            ' / ' +
            this.curAwardInner.rewardRecordextendConfigPrivacy.userCityName +
            ' / ' +
            this.curAwardInner.rewardRecordextendConfigPrivacy.userZoneName;
          extendConfig.userAddressDetail = this.curAwardInner.rewardRecordextendConfigPrivacy.userAddress;
          this.curAwardInner = Object.assign(extendConfig, this.curAwardInner);
        }
        this.popupType = NBBAwardPopupType.entityAwardOnline;
      } else if (award.goodsType === BWC.GoodsType.entityAward && award.collectionType === BWC.CollectionType.inStore) {
        // 实物 + 到店自提（直营店），展示线下核销码
        this.popupType = NBBAwardPopupType.entityAwardInStore;
      } else if (award.goodsType === BWC.GoodsType.virtualAward && award.collectionType === BWC.CollectionType.checkOffStrCode) {
        // 虚拟 + 线下核销发卡密，展示线下门店核销码，点击确定展示卡密
        this.popupType = NBBAwardPopupType.virtualAwardOfflineCode;
      } else if (award.goodsType === BWC.GoodsType.virtualAward && award.collectionType === BWC.CollectionType.inStore) {
        // 虚拟 + 线下核销，展示线下门店核销码
        this.popupType = NBBAwardPopupType.virtualAwardOffline;
      } else if (award.goodsType === BWC.GoodsType.virtualAward && award.collectionType === BWC.CollectionType.expressOrOnlineCheckOff) {
        // 虚拟 + 线上兑换，填写兑换信息，点击提交后，展示卡密
        this.popupType = NBBAwardPopupType.virtualAwardOnline;
      } else if (award.goodsType === BWC.GoodsType.giftCoupon)
        // 赠品券
        this.popupType = NBBAwardPopupType.giftCoupon;
      else {
        // 其他奖品领取方式
        Toast('奖品信息未匹配成功！');
        return false;
      }
      return true;
    },
    /**
     * 实物线上邮寄领取处理
     * @param {Object} data
     */
    entityAwardOnlineHandler(data) {
      const [awardObj, goodsIndex, params] = data;
      if (!awardObj) {
        this.$emit('nextStep', this.curAwardInner.jumpUrl, this.curAwardInner.jumpType); // 跳转配置用到，不用父组件则不加
        this.closeMask();
        return;
      }
      params['bigwheelRewardRecodeId'] = awardObj.recordId || awardObj.bigwheelRewardRecodeId;
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/reward/record/update',
        params: params,
        success: (r) => {
          if (r.code === 200) {
            Toast('领取成功！');
            setTimeout(() => {
              this.$emit('nextStep', this.curAwardInner.jumpUrl, this.curAwardInner.jumpType); // 跳转配置用到，不用父组件则不加
              // 刷新我的奖品
              this.$emit('refreshMyRecords');
              this.closeMask();
            }, 1000);
          } else {
            Toast(r.message);
          }
        },
        failure: () => {
          Toast('领取失败！');
        },
      });
    },
    /**
     * 跳转处理
     * @param {String} jumpUrl 跳转链接
     * @param {String} jumpType 跳转类型
     */
    nextStep(jumpUrl, jumpType) {
      this.$emit('nextStep', jumpUrl, jumpType);
    },
    /**
     * 跳转到中奖者名单页面
     */
    goWinnerList() {
      this.$emit('goWinnerList');
    },
    /**
     * 虚拟+线下核销发卡密, 查询是否核销
     */
    getUsedFlag() {
      // 刷新我的奖品
      this.$emit('refreshMyRecords');
    },
    /**
     * 虚拟+线上兑换，领取奖品
     * @param {Array} msg
     */
    virtualOnlineHandler(msg) {
      let params = {};
      if (msg.length === 3) {
        params = {
          bigwheelRewardRecodeId: msg[0].recordId || msg[0].bigwheelRewardRecodeId,
          userInfoList: msg[2].userInfoList,
        };
      } else if (msg.length === 4) {
        params = {
          bigwheelRewardRecodeId: msg[0].recordId || msg[0].bigwheelRewardRecodeId,
          userName: msg[2],
          userPhone: msg[3],
        };
      } else {
        params = {
          bigwheelRewardRecodeId: msg[0].recordId || msg[0].bigwheelRewardRecodeId,
        };
      }
      params.referrFlag = this.userType === '2' ? '1' : '';
      this.$api.post({
        sc: 'mobileMarketing',
        url: 'h5/bigWheel/reward/record/update',
        params: params,
        success: (r) => {
          if (r.code === 200) {
            Toast('领取成功！');
            this.isReceived = true;
            // 刷新我的奖品
            this.$emit('refreshMyRecords');
          } else {
            Toast(r.message);
          }
        },
        failure: () => {
          Toast('领取失败！');
        },
      });
    },
    /**
     * 全部奖品领取处理，全部奖品先进行统一展示，然后依据下面的方法进行后续逻辑处理
     * appointmentFlag 1 预约导购
     * rewardType 奖品类型(0:未中奖,1:虚拟,2:实物,3:优惠券,4:积分,5:代金券,6:赠品券)
     * collectionType 领取类型(1:线上邮寄(实物)/线上兑换(虚拟);2:到店自提(实物)/线下核销(虚拟);3:线下核销发卡密(虚拟);4:门店免单);5:货柜自取
     * usedFlag 使用标识 (0.未领取,1.已领取,2.待领取,3.已预约,4.已核销,5.已免单,6.已过期")
     * extendConfigFlag 是否填写邮寄信息
     */
    GeneralAwardHandler() {
      const rewardType = this.curAwardInner.rewardType ? this.curAwardInner.rewardType : this.curAwardInner.goodsType;
      const appointmentFlag = this.curAwardInner.appointmentFlag;
      const collectionType = this.curAwardInner.collectionType;
      // 虚拟奖品
      if (rewardType === BWC.GoodsType.virtualAward) {
        setTimeout(async () => {
          // 需要预约导购
          if (
            appointmentFlag === BWC.appointmentFlag.need &&
            (collectionType === BWC.CollectionType.inStore || collectionType === BWC.CollectionType.checkOffStrCode)
          ) {
            const isNext = await this.getValidity();
            if (isNext) {
              this.jumpAppointmentGuide();
            }
          } else {
            // 无需预约导购，进行后续弹窗显示
            const res = this.openNextPage(this.curAwardInner);
            // 未匹配成功，则跳转中奖查询页
            if (!res) {
              this.winningInquiry();
            }
          }
        }, 0);
      } else if (rewardType === BWC.GoodsType.entityAward) {
        // 实物奖品
        if (appointmentFlag === BWC.appointmentFlag.need && collectionType === BWC.CollectionType.inStore) {
          this.jumpAppointmentGuide();
        } else {
          // 实物 + 线上邮寄
          if (collectionType === BWC.CollectionType.expressOrOnlineCheckOff) {
            const isExpired = this.curAwardInner.effectiveEndTime ? new Date() > new Date(this.curAwardInner.effectiveEndTime) : false;
            // 用户没有领取过奖品，且奖品领取时间已过期
            if (!this.isReceived && isExpired) {
              Toast('超过领取时间，无法兑换');
              return;
            } else {
              this.openNextPage(this.curAwardInner);
            }
          } else if (collectionType === BWC.CollectionType.inStore) {
            // 实物到店自提
            this.openNextPage(this.curAwardInner);
          } else {
            this.winningInquiry();
          }
        }
      } else if (rewardType === BWC.GoodsType.coupon || rewardType === BWC.GoodsType.voucher) {
        // 优惠券或代金券
        this.$emit('nextStep', this.curAwardInner.jumpUrl, this.curAwardInner.jumpType);
      } else if (rewardType === BWC.GoodsType.accumulatePoints) {
        // 积分
        // 跳转类型为不跳转，默认跳转到小程序的中奖查询页
        if (this.curAwardInner.jumpType === BWC.JumpType.noJump) {
          this.winningInquiry();
          return;
        }
        this.$emit('nextStep', this.curAwardInner.jumpUrl, this.curAwardInner.jumpType);
      } else if (rewardType === BWC.GoodsType.giftCoupon) {
        // 赠品券
        // 需要预约导购
        if (appointmentFlag === BWC.appointmentFlag.need) {
          this.jumpAppointmentGuide();
        } else {
          // 无需预约导购，展示二维码（同虚拟+线下核销弹窗）
          this.openNextPage(this.curAwardInner);
        }
      } else if (rewardType === BWC.GoodsType.noAward) {
        if (this.curAwardInner.jumpType === BWC.JumpType.noJump) {
          this.closeMask();
        } else {
          this.$emit('nextStep', this.curAwardInner.jumpUrl, this.curAwardInner.jumpType);
        }
      }
    },
    /**
     * 跳转HI荣耀小程序，中奖查询页
     */
    winningInquiry() {
      this.$emit('goHiHonorMiniProgram', 'rewardQuery');
    },
    goHiHonorMiniProgram(index) {
      this.$emit('goHiHonorMiniProgram', index);
    },
    /**
     * 跳转预约导购
     */
    async jumpAppointmentGuide() {
      const { result } = await this.checkShoppingGuide(this.curAwardInner.exchangeActivationCodeId);
      const path =
        result && result.guideId
          ? `subpackages/activity/pages/shoppersService/serviceDetail/service-detail?id=${result.guideId}&activityUrl=${this.activityUrl}`
          : `subpackages/activity/pages/shoppersService/createService/create-service?activationCodeId=${this.curAwardInner.exchangeActivationCodeId}&collectionType=${this.curAwardInner.collectionType}&drawType=${this.drawType}&activityUrl=${this.activityUrl}`;
      let url = `/${path}`;
      const userBase = sessionStorage.getItem('userInfo');
      if (!userBase || !userBase.member) {
        url += '&refresh=1';
      }
      sessionStorage.setItem('needRefreshPage', true);
      if (this.loginType === BWC.LoginType.Wechat) {
        wx.miniProgram.navigateTo({
          url: url,
          success: function () {
            console.log('跳转回小程序的页面success');
          },
          fail: function (res) {
            console.error('跳转回小程序的页面fail', res);
          },
        });
      } else {
        my.redirectTo({
          url: url,
        });
      }
    },
    /**
     * 检测是否已经预约成功了
     * @param {String} id
     */
    checkShoppingGuide(id) {
      return new Promise((resolve) => {
        this.$api.get({
          noLoading: true,
          sc: 'mobileMarketing',
          url: `guide/getGuideByActivationCodeId/${id}`,
          params: null,
          success: (r) => {
            resolve(r);
          },
        });
      });
    },
    // 校验核销码是否在有效期内
    getValidity() {
      const params = {
        goodsId: this.curAwardInner.goodsId || '', //(权益品id)",
        rewardRecodeId: this.curAwardInner.bigwheelRewardRecodeId || '', //(中奖记录表id)
        activityCode: this.curAwardInner.activityCode || '', //活动编码
      };
      return new Promise((resolve) => {
        this.$api.post({
          noLoading: true,
          sc: 'mobileMarketing',
          url: 'h5/bigWheel/getWriteOff',
          params: params,
          success: (r) => {
            if (r.code === Number('200')) {
              resolve(true);
            } else {
              // 提示核销码不在有效期
              Toast(r.message);
              resolve(false);
            }
          },
        });
      });
    },
    /**
     * 重通用组件弹窗，跳转到下一页
     */
    openNextPage(award) {
      this.closeMask();
      const res = this.prizesHandler(award);
      this.$nextTick(() => {
        this.openMask();
      });
      return res;
    },
    /**
     * 判断奖品是否需要预约导购
     */
    appointmentGuideJudge(award) {
      const appointmentFlag = award.appointmentFlag;
      const rewardType = award.rewardType ? award.rewardType : award.goodsType;
      const collectionType = award.collectionType;
      let needGuiding = false;
      // appointmentFlag === '1'表示可能需要预约导购，具体是否需要，看奖品类型和领取方式
      if (
        appointmentFlag === BWC.appointmentFlag.need &&
        (rewardType === BWC.GoodsType.entityAward || rewardType === BWC.GoodsType.virtualAward || rewardType === BWC.GoodsType.giftCoupon)
      ) {
        // 虚拟：线下核销，线下核销发卡密
        if (
          rewardType === BWC.GoodsType.virtualAward &&
          (collectionType === BWC.CollectionType.inStore || collectionType === BWC.CollectionType.checkOffStrCode)
        ) {
          needGuiding = true;
        }
        // 实物，到店自提
        if (rewardType === BWC.GoodsType.entityAward && collectionType === BWC.CollectionType.inStore) {
          needGuiding = true;
        }
        // 赠品券
        if (rewardType === BWC.GoodsType.giftCoupon) {
          needGuiding = true;
        }
      }
      return needGuiding;
    },
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/lucky-draw/lucky-draw-page/new-blind-box/general-lottery.vue